'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHELF_ACTION_TOGGLE_PRIVACY = exports.SHELF_ACTION_MOVE = exports.SHELF_ACTION_REMOVE = exports.SHELF_ACTION_ADD = exports.SHELF_GTM_CATEGORY = exports.TOGGLE_PRIVACY_SHELF_EVENT = exports.MOVE_TO_SHELF_EVENT = exports.REMOVE_FROM_SHELF_EVENT = exports.ADD_TO_SHELF_EVENT = undefined;
exports.composeShelfEvent = composeShelfEvent;
exports.composeAddToShelfEvent = composeAddToShelfEvent;
exports.composeRemoveFromShelfEvent = composeRemoveFromShelfEvent;
exports.composeUpdateShelfEvent = composeUpdateShelfEvent;

var _compose = require('./compose');

var ADD_TO_SHELF_EVENT = exports.ADD_TO_SHELF_EVENT = 'bc.addToShelf';
var REMOVE_FROM_SHELF_EVENT = exports.REMOVE_FROM_SHELF_EVENT = 'bc.removeFromShelf';
var MOVE_TO_SHELF_EVENT = exports.MOVE_TO_SHELF_EVENT = 'bc.moveToShelf';
var TOGGLE_PRIVACY_SHELF_EVENT = exports.TOGGLE_PRIVACY_SHELF_EVENT = 'bc.togglePrivacy';
var SHELF_GTM_CATEGORY = exports.SHELF_GTM_CATEGORY = 'v2-shelves';
var SHELF_ACTION_ADD = exports.SHELF_ACTION_ADD = 'v2-add';
var SHELF_ACTION_REMOVE = exports.SHELF_ACTION_REMOVE = 'v2-remove';
var SHELF_ACTION_MOVE = exports.SHELF_ACTION_MOVE = 'v2-move';
var SHELF_ACTION_TOGGLE_PRIVACY = exports.SHELF_ACTION_TOGGLE_PRIVACY = 'v2-toggle-privacy';

function composeShelfEvent(eventName, metadataIds, shelfName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: metadataIds.length,
    gtmLabel: shelfName,
    gtmCategory: SHELF_GTM_CATEGORY,
    gtmAction: action,
    metadataIds: metadataIds
  });
}

function composeAddToShelfEvent(metadataIds, shelfName) {
  return (0, _compose.composeAnalytics)([composeShelfEvent(ADD_TO_SHELF_EVENT, metadataIds, shelfName, SHELF_ACTION_ADD)]);
}

function composeRemoveFromShelfEvent(metadataIds, shelfName) {
  return (0, _compose.composeAnalytics)([composeShelfEvent(REMOVE_FROM_SHELF_EVENT, metadataIds, shelfName, SHELF_ACTION_REMOVE)]);
}

function composeUpdateShelfEvent(metadataIds, fromShelfName, toShelfName, toPrivateItem) {
  var events = [];

  if (fromShelfName && toShelfName && fromShelfName !== toShelfName) {
    events.push(composeShelfEvent(MOVE_TO_SHELF_EVENT, metadataIds, toShelfName, SHELF_ACTION_MOVE));
  }

  if (toPrivateItem !== undefined && toPrivateItem !== null) {
    var label = toPrivateItem ? 'private' : 'public';
    events.push(composeShelfEvent(TOGGLE_PRIVACY_SHELF_EVENT, metadataIds, label, SHELF_ACTION_TOGGLE_PRIVACY));
  }

  return (0, _compose.composeAnalytics)(events);
}

exports.default = {
  ADD_TO_SHELF_EVENT: ADD_TO_SHELF_EVENT,
  REMOVE_FROM_SHELF_EVENT: REMOVE_FROM_SHELF_EVENT,
  MOVE_TO_SHELF_EVENT: MOVE_TO_SHELF_EVENT,
  TOGGLE_PRIVACY_SHELF_EVENT: TOGGLE_PRIVACY_SHELF_EVENT,
  SHELF_GTM_CATEGORY: SHELF_GTM_CATEGORY,
  SHELF_ACTION_ADD: SHELF_ACTION_ADD,
  SHELF_ACTION_REMOVE: SHELF_ACTION_REMOVE,
  SHELF_ACTION_MOVE: SHELF_ACTION_MOVE,
  SHELF_ACTION_TOGGLE_PRIVACY: SHELF_ACTION_TOGGLE_PRIVACY,
  composeShelfEvent: composeShelfEvent,
  composeAddToShelfEvent: composeAddToShelfEvent,
  composeRemoveFromShelfEvent: composeRemoveFromShelfEvent,
  composeUpdateShelfEvent: composeUpdateShelfEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/shelvesEventComposer.js
// module id = 444
// module chunks = 0 2 4 6 7 8 9 10